import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import c from 'classnames';
import { Url } from '@wix/da-url';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import Timestamp from '../../../Timestamp';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { BiContextProvidedValue, BiData, } from '@wix/da-bi/pkg/events';
import { CommentContext } from '../../CommentContext';
import s from './CommentTimestamp.scss';
/** A timestamp with a link that goes to the comment's standalone page. */
var CommentTimestamp = function (_a) {
    var className = _a.className;
    var t = useTranslation().t;
    var comment = useContext(CommentContext).comment;
    var isMobile = useContext(MobileContext);
    var isEdited = !!comment.edited;
    var timestamp = isEdited ? comment.edited : comment.posted;
    var showEditedPrefix = isEdited && !isMobile;
    return (React.createElement(BiLink, { href: Url.commentLink(comment.typeId, comment.itemId, comment.commentId), className: c(s['root'], className), biData: BiData({
            evid: 100,
            itemid: comment.itemId,
            typeid: comment.typeId,
            sectionid: BiContextProvidedValue,
            sectionname: BiContextProvidedValue,
            section_typeid: BiContextProvidedValue,
            sectiontype: BiContextProvidedValue,
            widgetname: BiContextProvidedValue,
        }) },
        showEditedPrefix && "".concat(t('comment.info.edited'), " "),
        React.createElement(Timestamp, { timestamp: timestamp, showTooltip: true, isCapitalized: !showEditedPrefix })));
};
CommentTimestamp.displayName = 'CommentTimestamp';
export default CommentTimestamp;
//# sourceMappingURL=CommentTimestamp.js.map